module.exports = __webpack_public_path__ + "static/media/kmg-kalibrierung_Web_EN.a41df43a.jpg";